module.exports = __webpack_public_path__ + "img/it.5d16b908.svg";